/**
 * captain_customer_skip_allowed (migration b7d2e9c4f160): may this person walk
 * past the Customer step without the guest's details? An admin signed into a
 * pad always may (as with half quantities). UX only, by design: the server
 * still accepts an order with no customer, so an offline capture or a till
 * order is never refused over it (operating law 1).
 */
export function customerSkipAllowed(settings, user) {
  if (user?.role === "admin") return true;
  return String(settings?.captain_customer_skip_allowed ?? "true").toLowerCase() !== "false";
}

/**
 * The same setting on the billing PC, where it binds everyone. The till is
 * normally signed in as an admin, so the pad's admin exemption would make the
 * setting do nothing there (owner, 2026-10-24: skip was offered with the setting
 * off; bible §46, no fake configuration).
 */
export function tillCustomerSkipAllowed(settings) {
  return String(settings?.captain_customer_skip_allowed ?? "true").toLowerCase() !== "false";
}

/** The guest the Customer step requires when skipping is off: name and a 10-digit mobile. */
export function draftIdentifiesGuest(draft) {
  return !!(draft && String(draft.name || "").trim() && /^\d{10}$/.test(String(draft.phone || "").trim()));
}
